/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プレスリリース位置情報(カテゴリ)
 * @export
 * @interface PressReleaseLocationCategory
 */
export interface PressReleaseLocationCategory {
    /**
     * 位置情報(カテゴリ)id
     * @type {number}
     * @memberof PressReleaseLocationCategory
     */
    locationCateId: number;
    /**
     * 位置情報(カテゴリ)名
     * @type {string}
     * @memberof PressReleaseLocationCategory
     */
    locationCateName: string;
}

export function PressReleaseLocationCategoryFromJSON(json: any): PressReleaseLocationCategory {
    return PressReleaseLocationCategoryFromJSONTyped(json, false);
}

export function PressReleaseLocationCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressReleaseLocationCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'locationCateId': json['location_cate_id'],
        'locationCateName': json['location_cate_name'],
    };
}

export function PressReleaseLocationCategoryToJSON(value?: PressReleaseLocationCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'location_cate_id': value.locationCateId,
        'location_cate_name': value.locationCateName,
    };
}

